const eventTypes = {
  SAVE: "save",
  RESET: "reset",
};

export default eventTypes;
